import {
  Popper,
  ClickAwayListener,
  PopperPlacementType,
  Paper,
  SxProps,
  Grow,
} from '@mui/material';
import { ReactNode, useMemo } from 'react';

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null;
  placement?: PopperPlacementType;
  zIndex?: number;
  popperOptions?: {
    strategy?: 'absolute' | 'fixed';
  };
  onClose: () => void;
  children: ReactNode;
  sx?: SxProps;
  paperClassName?: string;
  mouseEvent?:
    | 'onClick'
    | 'onMouseDown'
    | 'onMouseUp'
    | 'onPointerDown'
    | 'onPointerUp'
    | false;
  touchEvent?: 'onTouchEnd' | 'onTouchStart' | false;
}

export const FormikPanel: React.FC<Props> = ({
  open,
  paperClassName = 'tw-border tw-px-4 tw-py-2 !tw-w-72',
  anchorEl,
  sx = { zIndex: 1100, transitionDuration: 300 },
  placement = 'bottom-start',
  popperOptions = { strategy: 'fixed' },
  onClose,
  children,
  mouseEvent = 'onMouseDown',
  touchEvent = 'onTouchStart',
}) => {
  const modifiers = useMemo(
    () => [
      {
        name: 'preventOverflow',
        enabled: true,
        options: {
          altAxis: true,
          altBoundary: false,
          tether: false,
          rootBoundary: 'viewport',
          padding: 8,
        },
      },
    ],
    [],
  );

  return (
    <ClickAwayListener
      onClickAway={onClose}
      mouseEvent={mouseEvent}
      touchEvent={touchEvent}
    >
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        sx={sx}
        popperOptions={popperOptions}
        modifiers={modifiers}
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className={paperClassName}>{children}</Paper>
          </Grow>
        )}
      </Popper>
    </ClickAwayListener>
  );
};

export default FormikPanel;
